import './index.scss';
import React from 'react';
import $ from 'jquery';
import _ from 'underscore';
import Input from '../index.jsx';

class PhoneInput extends React.Component {
  static displayName = 'PhoneInput';

  static defaultProps = {
    defaultCountry: 'us',
    autoPlaceholder: false,
    autoHideDialCode: false,
    nationalMode: false,
  };

  state = {
    isEditing: false,
  };

  componentDidMount() {
    // Note: Country Code "RD" indicates that the client is on a "reserved" address.
    // This should only occur when staging is being emulated in local development
    // to sort out staging-specific bugs. The geolocator that passes the country code
    // in already fakes its output when RAILS_ENV=developement.
    // To permit debugging of staging-specific bugs, we rewrite "RD" to "us".
    if (this.props.defaultCountry == 'RD') {
      this.props.defaultCountry = 'us';
    }
    $(this._getInputElement()).intlTelInput({
      defaultCountry: this.props.defaultCountry,
      preferredCountries: ['us'],
      autoPlaceholder: this.props.autoPlaceholder,
      nationalMode: this.props.nationalMode,
      autoHideDialCode: this.props.autoHideDialCode,
    });

    if (this.props.value) {
      $(this._getInputElement()).intlTelInput('setNumber', this.props.value);
    }
  }

  componentWillUnmount() {
    this._stopWatching();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isEditing === true && this.state.isEditing === false) {
      this._stopWatching();
    } else if (this.state.isEditing === true && prevState.isEditing === false) {
      this._startWatching();
    }
  }

  _getInputElement = () => {
    return this.refs.phone_input.refs.input;
  };

  _publishValue = () => {
    const val = $(this._getInputElement()).intlTelInput('getNumber');
    if (val !== this.props.value) {
      this.props.onChange(this.props.name, val);
    }
  };

  _startWatching = () => {
    this.watch = setInterval(this._publishValue, 300);
  };

  _stopWatching = () => {
    clearInterval(this.watch);
  };

  onFocus = (e) => {
    this.setState({ isEditing: true });

    setTimeout(() => {
      const input = this._getInputElement();
      typeof input.setSelectionRange === 'function' &&
        input.setSelectionRange(input.value.length, input.value.length);
    }, 10);
  };

  onBlur = (e) => {
    this.setState({ isEditing: false });
  };

  _inputProps = () => {
    return _.extend({}, _.omit(this.props, 'value'), {
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      ref: 'phone_input',
    });
  };

  render() {
    return (
      <div className="PhoneInput-wrapper">
        <Input {...this._inputProps()} />
      </div>
    );
  }
}

export default PhoneInput;
